var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48338 24.8423C1.92863 21.2639 1.67264 17.1806 1.57679 14.5639C1.53357 13.384 2.1689 12.4263 2.9582 12.4263H17.2498C18.0391 12.4263 18.6744 13.384 18.6312 14.5639C18.5353 17.1806 18.2794 21.2639 17.7246 24.8423C17.4676 26.5004 16.6521 27.7632 15.5268 28.0075C14.3673 28.2593 12.6065 28.4729 10.104 28.4729C7.60149 28.4729 5.8407 28.2593 4.68118 28.0075C3.55585 27.7632 2.74044 26.5004 2.48338 24.8423Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87097 22.7986C8.11098 23.2681 8.90959 24.2071 10.1838 24.2071C11.4581 24.2071 12.1694 23.2681 12.3658 22.7986",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97764 17.3738V18.4435",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.141 17.3738V18.4435",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8905 7.07738H8.31758C7.33094 7.07738 6.53113 5.88001 6.53113 4.40295C6.53113 2.92589 7.33094 1.72852 8.31758 1.72852H11.8905C12.8771 1.72852 13.6769 2.92589 13.6769 4.40295C13.6769 5.88001 12.8771 7.07738 11.8905 7.07738Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5353 12.4262V10.2867C16.5353 7.49004 15.3405 5.11114 13.6735 4.23145",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67273 12.4262V10.2867C3.67273 7.49004 4.86745 5.11114 6.53448 4.23145",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchant);
export default __webpack_public_path__ + "static/media/merchant.604b6588390213cb7e2ccaca71fceda1.svg";
export { ForwardRef as ReactComponent };